
import Gutter from '@/ui-kit/components/gutter';
import Typography from '@/ui-kit/components/typography';
import Button from '@/ui-kit/components/button';
import MarketplaceForProsSection from '../section';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import {
  StyleColorSchemeType,
  StyleSizeType,
  StylePositionType,
} from '@/ui-kit/styles/enums';
import MarketplaceForProsStoreName from '@/store/marketplace-for-pros/name';
import LazyImage from '@/components/lazy-image';
import ImageHelper from '@/utils/ImageHelper';
import { Breakpoints } from '@/ui-kit/styles/constants';
import { Comparator } from '@/ui-kit/enums';
import routes from '@/constants/routes';
import { MarketplaceForProsEvent } from '@/constants/AnalyticEvents';

export default {
  name: 'MarketplaceForProsFooterSection',
  components: {
    Typography,
    Gutter,
    Button,
    MarketplaceForProsSection,
    LazyImage,
  },
  data() {
    return {
      StyleColorSchemeType,
      StyleSizeType,
      StylePositionType,
      TypographyType,
      routes,
      MarketplaceForProsEvent,
    };
  },
  computed: {
    content() {
      return this.$store.state[MarketplaceForProsStoreName].footerContent;
    },
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(
        this.content.footer_image.dimensions,
      );
    },
    footerImageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: Breakpoints.XSmall,
          imageSize: 400,
        },
        {
          comparator: Comparator.Less,
          breakpoint: Breakpoints.Small,
          imageSize: 600,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: Breakpoints.Medium,
          imageSize: 750,
        },
      ];
    },
  },
};
